import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsProgressButtonModule } from '@lcs/shared/progress-button';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CallStateModule } from 'src/app/call-state/call-state.module';
import { NdtLogoModule } from 'src/app/common-components/ndt-logo/ndt-logo.module';
import { PasswordFormControlModule } from 'src/app/common-components/password-form-control/password-form-control.module';
import { NdtRoutes } from '../site-layout/models/route-definitions';
import { UserPasswordResetEffects } from '../user-password-reset/state/user-password-reset.effects';
import { UserPasswordResetComponent } from './container/user-password-reset.component';
import * as fromUserResetPassword from './state/user-password-reset.reducer';
import { UserPasswordResetViewComponent } from './views/user-password-reset-view.component';

const routes: NdtRoutes = [
   {
      component: UserPasswordResetComponent,
      path: '',
   },
];
@NgModule({
   declarations: [UserPasswordResetComponent, UserPasswordResetViewComponent],
   exports: [UserPasswordResetComponent, UserPasswordResetViewComponent],
   imports: [
      CallStateModule,
      CommonModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      LcsProgressButtonModule,
      ReactiveFormsModule,
      MatButtonModule,
      MatInputModule,
      NdtLogoModule,
      PasswordFormControlModule,
      RouterModule.forChild(routes),
      StoreModule.forFeature(fromUserResetPassword.userPasswordResetFeatureKey, fromUserResetPassword.reducer),
      EffectsModule.forFeature([UserPasswordResetEffects]),
   ],
})
export class UserPasswordResetModule {}
